const metaData = {
  fields: [
    'id',
    'name',
    'slot_selected',
    'test_event_id',
    'created_at',
    'request_id',
    'status',
    'evaluator_ids',
    'evaluation_in_charge',
    'paper_id',
    {
      evaluators: ['id', 'evaluation_request_id', { evaluator: ['id', 'displayName'] }],
    },
    { paper: ['questionAnswerKeys', 'paper_id', 'paper_smart_id', { product: ['id', 'name', 'tq'] }] },
    { evaluationInCharge: ['displayName'] },
    { test_events: ['name'] },
    { evaluations: ['id', 'name', { evaluation_candidates: ['id', 'candidate_id', 'candidate_name', 'application_id', 'answers', 'total_score'] }] },
  ],
}

export default metaData
